import React, { Component } from 'react';

import DailyNewsArticleBox from './daily-news-article-box';
import LoadingIndication from '../common/loading-indicator';
import AnimatedWrapper from '../core/animated-wrapper';
import shareService from '../../services/share';
import DailyNewsService from '../../services/daily-news';
import SmartAd from '../ads/smart-ad';
import AdUIService from '../../services/ads/ui';
import VirtualScrollingService from '../../services/virtual-scrolling';

import './daily-news.css';

const moment = require('moment');

class DailyNews extends Component {
  isInPagePull = false;

  constructor(props) {
    super(props);

    const queryStringStr = (props.location.search || '').replace('?', '');

    // postsNum / ids
    const queryStrMap = queryStringStr
      .split('&')
      .filter(x=> x && x.length > 0)
      .reduce((all, queryStr) => {
        const [key, value] = queryStr.split('=');
        return {
          ...all,
          [key]: value
        };
      }, {});

    this.state = {
      isLoading: true,
      isPartialLoading: true,      
      isError: false, 
      isThereMorePages: true,
      currentPage: 1, 
      tag: queryStrMap.tag,
      currentArticlesNum: 0,    
      articlesByMonth: {}
    };

    shareService.setupPage({
      title: "Daily-news"
    });     

    this.debouncedOnScroll = VirtualScrollingService.debounce(this.onScroll, 10);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.debouncedOnScroll);
    this.fetchPage(this.state.currentPage, this.state.tag);
  }

  fetchPage(page, tag) {
    this.isInPagePull = true;

    DailyNewsService.getNews(page, tag)
      .then((articlesResponse) => {
        this.setState((prevState) => {
          const newArticlesByMonth = Object.assign({}, prevState.articlesByMonth);

          articlesResponse.news.forEach((article) => {
            const monthKey = moment(article.date).format('YYYYMM');
            const currentArr = newArticlesByMonth[monthKey];

            if (currentArr) {
              currentArr.push(article);
              return;
            }

            newArticlesByMonth[monthKey] = [article];
          });

          const newCount = prevState.currentArticlesNum + articlesResponse.news.length;
          const isThereMorePages = newCount !== articlesResponse.total;

          return {
            isLoading: false,
            isPartialLoading: false,
            isError: false,
            isThereMorePages,
            articlesByMonth: newArticlesByMonth,
            currentArticlesNum: newCount,
            currentPage: page
          };
        }, () => {
          this.isInPagePull = false;
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: false
        });
      });
  }

  getArticlesPartJSX() {
    if (this.state.articlesByMonth.length === 0) {
      return (
        <p>There is no daily news</p>
      );
    }
    else {
      return Object.keys(this.state.articlesByMonth).reverse().map((monthKey) => {
        const monthArticles = this.state.articlesByMonth[monthKey];
        const articlesJSX = monthArticles.map((article) => 
          <DailyNewsArticleBox {...article} key={`daily-news-article-summary-article-${article._id}`} />
        );

        const articlesJSXWithAds = AdUIService.putEvery(articlesJSX, SmartAd, 2, 14, { forceShowAd: true });

        const monthNameAndYear = moment(monthArticles[0].date).format('MMMM, YYYY');
        
        return (
          <section key={`daily-news-article-summary-month-${monthKey}`} className='month-articles-container'>
            <h4>{monthNameAndYear}</h4>

            <div className='articles'>
              {articlesJSXWithAds}
            </div>

            <hr />
          </section>
        );
      });
    }
  }

  onScroll = () => {
    if (this.state.isPartialLoading || !this.articlesRef || this.isInPagePull || !this.state.isThereMorePages) {
      return;
    }

    const isFetchNeeded = VirtualScrollingService.isFetchNeeded(this.articlesRef);
    if (!isFetchNeeded) return;

    this.setState({
      isPartialLoading: true
    });

    this.fetchPage(this.state.currentPage + 1, this.state.tag);
  }

  setArticlesContainerRef = (articlesRef) => {
    this.articlesRef = articlesRef;
  }

  getPartialLoadingJSX() {
    if (this.state.isPartialLoading) {
      return (
        <div className='partial-loading-container'>
          <LoadingIndication />
        </div>
      );
    }

    return '';
  }

  render() {
    let extraJSX;
    
    if (this.state.isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      extraJSX = (
        <div>
          {/*<p className='shown-articles-count'>
            Show {this.state.shownArticles.length} out of {this.state.filteredTagArticlesNum} recommendations for 
            <span className='selected-tag'>{this.state.filterByTag.text}</span>
            tag
          </p>*/}

          <div className='articles' ref={this.setArticlesContainerRef}>
            {this.getArticlesPartJSX()}
          </div>

          {this.getPartialLoadingJSX()}
        </div>
      );
    }

    return (
      <section className='regular-page daily-news-container'>
        <h3 className='page-title'>Daily News</h3>
        <hr className='title-separator' />

        {extraJSX}
      </section>
    );
  }
}

const AnimatedDailyNews = AnimatedWrapper(DailyNews);
export default AnimatedDailyNews;
